<template>
  <div class="in_boxnew">
    <!-- title -->
    <div style="width: 100%; display: block; padding: 25px 0">
      <in-title
         class="wow bounceIn animated"
        :titletxt="lange == 'ch' ? obj.inTitle4.ch : obj.inTitle4.en"
        colors="color:#171d42;"
        xiancolor="background-color:#646881;"
        zong="0"
      />
    </div>

    <div class="in_newBox">
      <div class="in_newCent">
        <!-- nav start -->
        <div class="in_newNav">
          <span
            class="wow bounceIn animated"
            v-for="(item, index) in navList"
            :key="index"
            :style="
              indexNe == index
                ? 'background-color:#bda67d;color:#fff;border:1px solid #bda67d;'
                : ''
            "
            @click="clickInen(index, item.id)"
            v-if="index < 3"
            >{{ lange == "ch" ? item.cnName : item.enName }}</span
          >
        </div>
        <!-- nav end -->

        <div class=" in_newLeft">
          <div class="wow bounceInLeft animated in_newLeftBox">
            <!-- <img :src="obj.inTitle4.list[0].img" /> -->

              <img class="div_img" :src="nimg.imgFiles" v-if="nimg != null && nimg.imgFiles != '' && nimg.imgFiles != null">

            <div class="in_newTite" v-if="nimg != null">
              {{ lange == "ch" ? nimg.cnTitle : nimg.enTitle }}
            </div>
            <div class="in_newCat" v-if="nimg != null" v-html="lange == 'ch' ? nimg.cnDetailTxt : nimg.enDetailTxt">
              {{ lange == "ch" ? nimg.cnDetailTxt : nimg.enDetailTxt }}
            </div>
            <div class="in_newDetal" v-if="nimg != null">
              <router-link :to="'/Details?id=' + nimg.id">{{
                lange == "ch"
                  ? obj.inTitle4.list[0].detl.ch
                  : obj.inTitle4.list[0].detl.en
              }}</router-link>
            </div>
          </div>

          <div class="wow bounceInRight animated in_newRight">
            <router-link
              class="in_newList"
              v-for="(item, index) in newsList"
              :key="index"
              v-if="index > 0 && index < 6"
              :to="'/Details?id=' + item.id"
            >
              <div class="in_newDate">
                <span>{{ item.r }}</span>
                <span>{{ item.n }}</span>
              </div>
              <div class="in_newTxt">
                <div>{{ lange == "ch" ? item.cnTitle : item.enTitle }}</div>
                <div v-html="lange == 'ch' ? item.cnDetailTxt : item.enDetailTxt">

                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="in_newMck">
      <router-link to="/latestinformation">{{
        lange == "ch" ? obj.lookMore.ch : obj.lookMore.en
      }}</router-link>
    </div>
  </div>
</template>

<script>
//新闻资讯
import InTitle from "./InTitle";
import { newsFenlei, newsList } from "@/api/index";
export default {
  name: "LatestInformations",
  components: { InTitle },
  computed: {},
  data() {
    return {
      // obj: {},
      lange: this.$cookies.getCookie("language"),
      indexNe: 0,
      navList: [],
      newsList: [],
      nimg: {},
    };
  },
  created() {
    this.obj = this.$store.state.indexText;
    this.newsApiFunc();
    this.newsListFunc();
  },
  methods: {
    clickInen(index, id) {
      this.indexNe = index;
      this.newsListFunc(id);
    },
    newsApiFunc() {
      //新闻分类导航
      newsFenlei()
        .then((response) => {
          this.navList = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    newsListFunc(id, pageNum) {
      //新闻列表
      var params = {
        category: id || "",
        pageNum: pageNum || 1,
      };
      newsList(params)
        .then((response) => {
          var n = response.data.list[0] || null;
          if(n != null && n.imgFiles != null){
            n.imgFiles = n.imgFiles.split(",")[0];
            //n.imgFiles = "http://www.easytimesip.com"+n.imgFiles.substr(1,n.imgFiles.length);
          }
          this.nimg = response.data.list[0] || null;
          var arr = response.data.list;
          for (var i = 0; i < arr.length; i++) {
            arr[i].n = this.timestampToTime(arr[i].showTime, "n");
            arr[i].r = this.timestampToTime(arr[i].showTime, "r");
          }
          this.newsList = arr;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    timestampToTime: function (timestamp, b) {
      //时间戳转换，日期
      var date = new Date(
        timestamp.toString().length < 13 ? timestamp * 1000 : timestamp * 1
      ); //时间戳为10位需*1000，时间戳为13位的话不需乘1000 用 乘以1
      var Y = date.getFullYear() + "";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "/";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      // return Y + M + D; //+h+m+s;
      if (b == "n") {
        return Y;
      } else {
        return M + D;
      }
    },
  },
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.in_boxnew {
  width: 100%;
  display: block;
  position: relative;
}
.in_newBox {
  width: 100%;
  display: block;
}
.in_newCent {
  width: 62.5%;
  display: block;
  margin: 0 auto;
  position: relative;
}
  .in_newNav {
    width: 100%;
    display: block;
    text-align: center;
    margin: 0 0 0px 0;
  }
@media only screen and (min-width: 800px){
  .in_newNav {
    width: 100%;
    display: block;
    text-align: center;
    margin: 0 0 30px 0;
  }
}
.in_newNav > span {
  font-size: 18px;
  color: #aeaeae;
  display: inline-block;
  border: 1px solid #d7dadd;
  border-radius: 26px;
  padding: 8px 30px;
  margin: 0 10px 10px 10px;
  cursor: pointer;
}
.in_newLeft {
  width: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.in_newLeftBox {
  width: 48%;
  display: block;
}
.in_newLeftBox > img {
  width: 100%;
  display: block;
}
.in_newTite {
  width: 100%;
  display: block;
  margin: 40px 0 20px 0;
  font-size: 18px;
  color: #02182c;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.in_newCat {
  width: 100%;
  display: block;
  font-size: 14px;
  color: #7a7a7a;
  line-height: 30px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.in_newDetal {
  display: inline-block;
  font-size: 16px;
  border-bottom: 2px solid #bda67d;
  line-height: 30px;
  margin: 30px 0 0 0;
}
.in_newDetal > a {
  color: #bda67d;
}
.in_newRight {
  width: 46%;
  display: block;
  position: relative;
}
.in_newList {
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 0 0 38px 0;
}
.in_newDate {
  width: 15%;
  display: block;
}
.in_newTxt {
  width: 80%;
  display: block;
  box-sizing: border-box;
  border-left: 5px solid #bda67d;
}
.in_newDate > span {
  width: 100%;
  display: block;
  text-align: right;
}
.in_newDate > span:nth-child(1) {
  font-size: 22px;
  color: #bda67d;
  margin: 0 0 5px 0;
}
.in_newDate > span:nth-child(2) {
  font-size: 12px;
  color: #02182c;
  font-weight: bold;
}
.in_newTxt > div {
  width: 95%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 0 0 5%;
}
.in_newTxt > div:nth-child(1) {
  font-size: 18px;
  color: #02182c;
  font-weight: bold;
}
.in_newTxt > div:nth-child(2) {
  font-size: 14px;
  color: #acacac;
  margin-top: 10px;
}
.in_newMck {
  width: 100%;
  display: block;
  text-align: center;
  margin: 60px 0;
}
.in_newMck > a {
  font-size: 14px;
  padding: 10px 48px;
  border-radius: 6px;
  border: 1px solid #bda67d;
  color: #bda67d;
}
.div_img {
  width: 100%;
  display: block;
  position: relative;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

@media only screen and (max-width: 1440px) {
  .in_newCent {
    width: 90%;
  }
}

@media only screen and (max-width: 768px) {
  .in_newLeft {
    flex-wrap: wrap;
  }
  .in_newLeftBox {
    width: 100%;
    margin-bottom: 25px;
  }
  .in_newRight {
    width: 100%;
    display: block;
    position: relative;
  }
  .in_newDate > span:nth-child(1) {
    font-size: 18px;
  }
}
@media only screen and (max-width: 425px) {
  .in_newNav {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .in_newNav > span {
    font-size: 12px;
    width: 30%;
    display: inline-block;
    padding: 0;
    margin: 0 0 20px 0;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .in_newTite {
    margin: 20px 0 10px 0;
    font-size: 14px;
  }
  .in_newCat {
    font-size: 12px;
    line-height: 20px;
  }
  .in_newTxt > div:nth-child(1) {
    font-size: 14px;
    font-weight: 400;
  }
  .in_newDate > span:nth-child(1) {
    font-size: 14px;
  }
  .in_newTxt > div:nth-child(2) {
    font-size: 12px;
    margin-top: 5px;
  }
  .in_newList {
    margin: 0 0 20px 0;
  }
  .in_newMck {
    margin: 30px 0;
  }
  .in_newDetal {
    font-size: 12px;
    margin: 3px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/component/LatestInformations.vue